import React, { useState, useEffect } from 'react';
import { time12 } from '../functions/functions';
import { FiSearch, FiXCircle, FiEdit } from "react-icons/fi"
import { useParams } from 'react-router-dom';
import ItemWConf from './ItemWConf';
import Alert from './Alert';
import {Link} from "react-router-dom"
import { Navigate, useNavigate } from "react-router-dom";

import { db, auth } from '../functions/firebaseFunctions';
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
const EventScreen = ({ route, navigation }) => {
  function star(item, val, typ) {
    let itemId;

    if (typ === 'venues') {
      itemId = item.venueId;
    } else if (typ === 'services') { itemId = item.artistId + '_' + item.type; }
    return (
      <div style={{ margin: 5, height: 100 }}
        onClick={() => {
          if (typ == 'services') {
            if (item.rated == undefined) {
              db.collection('ratings')
                .doc(typ)
                .collection(item.artistId)
                .add({
                  placeholder: true, rating: val, uid: auth.currentUser?.uid, type: item.type,
                });
            } else {

              db.collection('ratings')
                .doc(typ)
                .collection(item.artistId)
                .where('uid', '==', auth.currentUser?.uid)
                .onSnapshot(r => {
                  let docId = r.docs[0].id;
                  db.collection('ratings')
                    .doc(typ)
                    .collection(item.artistId)
                    .doc(docId)
                    .set({ placeholder: true, rating: val, uid: auth.currentUser?.uid, type: item.type }, { merge: true });
                });
            }


          } else if (typ == 'venues') {
            if (item.rated == undefined) {
              db.collection('ratings')
                .doc(typ)
                .collection(itemId)
                .add({
                  venueId: itemId,
                  rating: val,
                  uid: auth.currentUser?.uid,
                });
            } else {
              db.collection('ratings')
                .doc(typ)
                .collection(itemId)
                .where('uid', '==', auth.currentUser?.uid)
                .onSnapshot(r => {
                  let docId = r.docs[0].id;
                  db.collection('ratings')
                    .doc(typ)
                    .collection(itemId)
                    .doc(docId).set({
                      venueId: itemId,
                      rating: val,
                      uid: auth.currentUser?.uid,
                    }, { merge: true }).catch(err => console.log(err));

                });
            }
          }

        }
        }>
        <div width="30" height="28" viewBox="0 0 30 28" fill="none"
          stroke={'var(--org)'} stroke-width="1">
          <div fill={val <= item.rated ? 'var(--org)' : 'none'}
            d="M15 0L18 10H29L20.5 17L24 27L15 21L6 27L9.5 17L1 10H12L15 0Z" />
        </div>
      </div>
    );
  }

  const [once, setOnce] = useState(true);
  const [mydata, setmydata] = useState(null);
  const uid = auth.currentUser?.uid
  const { eventId } =  useParams()
  const navigateTo = useNavigate();
  const [Err, setErr] = useState(null);
  const [name, setName] = useState(null);

  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);
  const [owner, setOwner] = useState(false);
  const [type, setType] = useState(null);
  const evStart = new Date(start);
  const evEnd = new Date(end);
  const [ents, setEnts] = useState(null);
  const [vens, setVens] = useState(null);
  const [past, setPast] = useState(false);
  const [alert, setAlert] = useState(null);
  // console.log('auth.currentuseruid:', auth.currentUser?.uid, 'uid:', uid, 'eventId:', eventId);

  useEffect(() => {

    if (uid == auth.currentUser?.uid) {
      setOwner(true);
    }
    db.collection('events').where('uid', '==', uid)
      .where('docid', '==', eventId)
      .limit(1)
      .get().then((eve) => {
        const event = eve.docs[0]?.data();
        setName(event.name);
        setStart(event.start.toDate());
        setEnd(event.end.toDate());
        setType(event.type);
        const now = new Date();
        const end = new Date(event.end.toDate());

        if (now > end) {
          setPast(true);
        }


        db.collection('bookings').doc(eventId).collection('etts')
          .get().then((eve) => {


            if (!eve.empty) {
              const arr = [];
              eve.docs.forEach((x) => {
                const service = x.data();

                let status = service.status;
                if (status == 'Deleted') { status = 'Canceled'; } else
                  if (now > end) {
                    status = 'Expired';
                  }
                db.collection('ratings')
                  .doc('services')
                  .collection(service.docid)
                  .where('uid', '==', uid)
                  .onSnapshot(r => {
                    let rating;
                    if (!r.empty) {
                      rating = r.docs[0].data().rating;
                    }
                    arr.push({
                      artistId: service.docid,
                      name: service.name,
                      status: status,
                      type: service.type,// singer...
                      price: service.price,
                      rated: rating,
                      uid: uid,
                      eventId: eventId,
                      bookingId: service.docid,
                      paymentIntentId: service.paymentIntentId,
                      duration: (event.end.valueOf() - event.start.valueOf()) / 3600,
                      midPath: 'etts',
                    });
                    setEnts(arr);
                  });
              });
            }

          }).catch(e => { console.log('bookings/id/etts', e); });

        db.collection('bookings').doc(eventId).collection('ven')
          .get().then((vens) => {
            let arr = [];

            if (!vens.empty) {
              vens.docs.forEach(v => {
                const venue = v.data();

                let status = venue.status;
                if (status == 'Deleted') { status = 'Canceled'; } else
                  if (now > end) { status = 'Expired'; }

                db
                  .collection('ratings')
                  .doc('venues')
                  .collection(venue.venueId)

                  .where('venueId', '==', venue.venueId)
                  .where('uid', '==', auth.currentUser?.uid)
                  .onSnapshot((r) => {

                    let rating;
                    if (!r.empty) {
                      rating = r.docs[0].data().rating;

                    }
                    arr.push({
                      ownerId: venue.docid,
                      venueName: venue.name,
                      status: status,
                      price: venue.price,
                      venueId: venue.venueId,
                      address: venue.address,
                      rated: rating,
                      uid: uid,
                      type: venue.type,
                      eventId: eventId,
                      bookingId: venue.docid,
                      midPath: 'ven',
                      paymentIntentId: venue.paymentIntentId,
                    });
                    setVens(arr);

                  });
              });
            }

          }).catch(e => { console.log('bookings/id/vens', e); });

      });


  }, []);
  return (
    <div className='EventScreen' >
      <div style={{display: 'flex', flexDirection: 'column', justifySelf: 'center', padding: 10,  width: '550px', }} >
        {alert && <Alert title="Are you sure?"
          setAlert={setAlert}
          comment={alert.comment}
          options={alert.options}
        />}
        {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
        {name && <h1 style={{textAlign: 'center', marginBlockEnd: 15}}>{eventId === 'new' ? 'New event' : name} - {type && type}</h1>}
        <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
        <div className='forNarrow' style={{display: 'flex', justifyContent: 'space-between', padding: 5, paddingInline: 10, textAlign: 'center'}}>
          <p style={{color: 'white'}}>Starts on {months[evStart.getMonth()]} {evStart.getDate()} at {time12(evStart)}</p>
          <p style={{color: 'white'}}>Ends on {months[evEnd.getMonth()]} {evEnd.getDate()} at {time12(evEnd)}</p>
        </div>
          <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
        <div>

          {owner == true ? <div >
            {(past == false || ents) && <div >
              {/* <div style={{display: 'flex', flexDirection: 'row'}}> */}
              <div className='forNarrow' style={{display: 'flex', justifyContent: 'space-between', paddingInline: 10,}}>
                <p style={{ color: 'white', alignSelf: 'center', paddingBlock: 5,}}>Entertainment:</p>
                {ents && <div className='centered' >
                  {ents.map(ent =>
                      <ItemWConf item={ent}
                      F={'Service'}
                      navigation={navigation}
                      styleDirection={'inline'}
                      event={{
                        name: name, type: type,
                        date: months[evStart.getMonth()] + evStart.getDate(),
                        timeS: time12(evStart), timeE: time12(evEnd),
                      }}
                      link={() => {
                        // console.log('Service',
                        //   { uid: uid, artuid: ent.artistId, type: ent.type, name: ent.name, price: ent.price });
                      }}
                      onDelete={() => {
                        db.collection('bookings').doc(eventId).collection('etts')
                          .doc(ent.artistId).delete().then(() => {
                            setOnce(true); setEnts(null);
                          }).catch(e => { setErr(e); });
                      }}
                      onCancel={() => {
                        db.collection('bookings').doc(eventId).collection('etts').doc(ent.artistId)
                          .update({ status: 'Canceled' }).then((e) => {
                            setOnce(true);
                          }).catch(e => { setErr(e); });
                      }}
                      setAlert={setAlert}
                      extraContent={ent.status == 'Expired' && <div>

                        <p style={{ color: 'var(--org)', fontSize: 16, textAlign: 'center', margin: 5 }}>Rate your Experience:</p>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingBottom: 10 }}>
                          {star(ent, 1, 'services')}
                          {star(ent, 2, 'services')}
                          {star(ent, 3, 'services')}
                          {star(ent, 4, 'services')}
                          {star(ent, 5, 'services')}
                        </div>
                      </div>}
                    />
                  )}
                </div>}
                {past == false && 
                <button
                  style={{
                    color: "var(--wht)",
                    alignSelf: 'center',
                    borderWidth: 0,
                    paddingInline: 0,
                    paddingBlock: 5,
                  }}
                  onClick={() => {
                        console.log('Browse', { uid: uid, tabR: 'Services' });
                  }}>
                  Find Entertainment  <FiSearch style={{ marginLeft: 10 }} />
                </button>
                }
              </div>
              <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
            </div>}
            {(past == false || vens) && <div>
              <div className='forNarrow' style={{display: 'flex', justifyContent: 'space-between', paddingInline: 10, }}>
                <p style={{ color: 'white', alignSelf: 'center', paddingBlock: 5 }}>Venue:</p>
                {vens && <div className='centered'>
                  {vens.map(ven =>
                      <ItemWConf item={ven}
                      F={'Service'}
                      navigation={navigation}
                      styleDirection={'inline'}
                      event={{
                        name: name, type: type,
                        date: months[evStart.getMonth()] + evStart.getDate(),
                        timeS: time12(evStart), timeE: time12(evEnd),
                      }}
                      link={() => {
                        navigation.navigate('Service',
                          { uid: uid, artuid: ven.artistId, type: ven.type, name: ven.name, price: ven.price });
                      }}
                      onDelete={() => {
                        db.collection('bookings').doc(eventId).collection('etts')
                          .doc(ven.artistId).delete().then(() => {
                            setOnce(true); setEnts(null);
                          }).catch(e => { setErr(e); });
                      }}
                      onCancel={() => {
                        db.collection('bookings').doc(eventId).collection('etts').doc(ven.artistId)
                          .update({ status: 'Canceled' }).then((e) => {
                            setOnce(true);
                          }).catch(e => { setErr(e); });
                      }}
                      setAlert={setAlert}
                      extraContent={ven.status == 'Expired' && <div>

                        <p style={{ color: 'var(--org)', fontSize: 16, textAlign: 'center', margin: 5 }}>Rate your Experience:</p>
                        <div style={{ flexDirection: 'row', justifyContent: 'center', paddingBottom: 10 }}>
                          {star(ven, 1, 'services')}
                          {star(ven, 2, 'services')}
                          {star(ven, 3, 'services')}
                          {star(ven, 4, 'services')}
                          {star(ven, 5, 'services')}
                        </div>
                      </div>}
                    />
                  )}
                </div>}
                {past == false && 
                <button
                  style={{
                    color: "var(--wht)",
                    alignSelf: 'center',
                    borderWidth: 0,
                    paddingInline: 0,
                    paddingBlock: 5
                  }}
                  onClick={() => {
                        console.log('Browse', { uid: uid, tabR: 'Venues' });
                  }}>
                  Find Venue  <FiSearch style={{ marginLeft: 10 }} />
                </button>
                }
              </div>
              <hr style={{ borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5 }} />
            </div>}
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
              {past === false && 
                <Link className='buttonHov' to={`/edit_event/${eventId}`}>
                  <div style={{fontSize: 16, display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 15}}>
                    <p  style={{fontSize: 16, color: 'white', textTransform: 'uppercase'}}>Edit Event </p> <FiEdit style={{marginInlineStart: 10, fontSize: 16, color: 'white',  }}/>
                  </div>
                </Link>
              }
              <button
                style={{
                  color: "var(--red)",
                  alignSelf: 'center',
                  borderWidth: 0,
                  fontSize: 16,
                }}
                onClick={() => {
                  setAlert({
                    comment: 'Delete event', options: [
                      { text: 'No', style: 'cancel' },
                      {
                        text: 'Delete', onClick: async () => {
                          var uid = auth.currentUser?.uid;

                          if (uid) {

                            db.collection('events').doc(eventId).delete().then(() => {
                              console.log('Document successfully deleted!');
                              navigateTo('/Profile/dashboard');
                              db.collection('bookings').doc(eventId).delete().then(() => {
                                if (ents.length > 0) {
                                  db.collection('bookings').doc(eventId).collection('etts').doc(ents[0].artistId).delete().then(() => {
                                  }).catch(e => { setErr(e); });
                                }
                                if (vens) {
                                  vens.map(x => {
                                    let venid = x.venueId;
                                    db.collection('venue').doc(venid).collection('events')
                                      .doc(eventId).delete().then(() => {
                                        navigation.goBack();
                                      }).catch(e => { setErr(e); });
                                  });
                                } else {
                                  navigation.goBack();
                                }
                                navigation.goBack();
                              }).catch(e => { setErr(e); });
                            }).catch(e => { setErr(e); });
                          }
                        }, style: 'destructive',
                      },
                    ],
                  });
                
                }}>
                Delete Event <FiXCircle style={{ marginLeft: 10 }} />
              </button>
            </div>
          </div>
            : <div>
              <p style={{ fontSize: 16, fontWeight: 'bold', textAlign: 'center', margin: 5 }}>Location:</p>
              {vens ? <div
                style={{ borderColor: 'gray', borderWidth: 1, borderRadius: 5, margin: 5, padding: 10, alignItems: 'center' }}
                onClick={() => {
                  console.log('Venue', { uid: auth.currentUser?.uid, price: vens[0].price, name: vens[0].name, ownerId: vens[0].ownerId, venueId: vens[0].venueId, address: vens[0].address });
                }}
              >
                <p >{vens[0].name} - {vens[0].address}</p>
              </div>
                : <p style={{ textAlign: 'center' }}>No location is set yet</p>}
            </div>}
        </div>
      </div>
    </div>
  );
};

export default EventScreen;
